<template>
  <v-container>
    <v-layout row wrap class="mb-5">
      <v-flex xs12 md12>
        <v-layout align-center>
          <h1 class="primary--text mr-3">Beneficiary Categories</h1>
          <v-btn small depressed color="accent" to="/beneficiaries/create">
            <v-icon small>add</v-icon>Add Category
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Search" single-line></v-text-field>
        </v-layout>
      </v-flex>
    </v-layout>

    <app-alert
      class="mb-3"
      type="success"
      message="Beneficiary successfully created."
      v-if="$route.query.beneficiaryCreated"
    />
    <!-- <app-alert class="mb-3" type="success" :message="beneficiary.updated" /> -->

    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title class="subheading font-weight-bold px-4">
            <span v-if="search !== ''">Results for "{{ search }}"</span>
            <span v-else>All Beneficiary Categories</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table
            :headers="headers"
            :items="beneficiaryCategories"
            :loading="isLoading"
            :search="search"
            :rows-per-page-items="[30, 60, 100]"
            no-data-text="No beneficiaries available"
          >
            <template v-slot:items="props">
              <td>{{ (props.index + 1) }}</td>
              <td v-if="beneficiary.editing === props.item._id">
                <v-text-field v-model="beneficiary.cached.name" @input="beneficiary.canSave = true"></v-text-field>
              </td>
              <td v-else>{{ props.item.name }}</td>

              <td v-if="beneficiary.editing === props.item._id">
                <v-text-field
                  v-model="beneficiary.cached.description"
                  maxlength="160"
                  @input="beneficiary.canSave = true"
                ></v-text-field>
              </td>
              <td v-else>{{ props.item.description }}</td>

              <td v-if="beneficiary.editing === props.item._id">
                <v-select
                  v-model="beneficiary.cached.status"
                  :items="statusOptions"
                  @input="beneficiary.canSave = true"
                ></v-select>
              </td>
              <td v-else>
                <v-chip
                  small
                  :color="props.item.status === 'active' ? 'green' : 'red'"
                  text-color="white"
                >{{ $lang(props.item.status) }}</v-chip>
              </td>

              <td v-if="beneficiary.editing === props.item._id">
                <v-btn
                  small
                  depressed
                  color="success"
                  @click="updateBeneficiary()"
                  :disabled="beneficiary.isSaving || !beneficiary.canSave"
                >Save</v-btn>
                <v-btn small flat @click="cancelEdit()" :disabled="beneficiary.isSaving">Cancel</v-btn>
              </td>
              <td v-else>
                <v-icon small class="mr-2" @click="editMode(props.item)">edit</v-icon>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { FETCH_CATEGORY, UPDATE_CATEGORY } from '@/store/actions/category'
import { statusOptions } from '@/data/options'

export default {
  name: 'Beneficiaries',
  created () {
    this.isLoading = true
    this.$store.dispatch(FETCH_CATEGORY, { model: 'beneficiary' })
      .finally(() => (this.isLoading = false))
  },
  data () {
    return {
      search: this.$route.query.s || '',
      beneficiary: {
        editing: null,
        cached: null,
        updated: false,
        canSave: false,
        isSaving: false
      },
      isLoading: false,
      statusOptions: statusOptions,
      headers: [
        { text: '#', value: 'index', sortable: false },
        { text: 'Name', value: 'name' },
        { text: 'Description', value: 'description' },
        { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'actions', sortable: false }
      ]
    }
  },
  methods: {
    editMode (beneficiary) {
      this.beneficiary.canSave = false
      this.beneficiary.updated = false
      this.beneficiary.editing = beneficiary._id
      this.beneficiary.cached = Object.assign({}, beneficiary)
      delete this.beneficiary.cached.created // removes the created timestamp
      delete this.beneficiary.cached.modified // removes the modified timestamp
    },
    updateBeneficiary () {
      if (this.$validator.isRequired(this.beneficiary.cached.name) !== true || 
        this.$validator.isRequired(this.beneficiary.cached.description) !== true
        ) return
        
      this.beneficiary.isSaving = true
      this.$store.dispatch(UPDATE_CATEGORY, { model: 'beneficiary', data: this.beneficiary.cached })
        .then(() => {
          this.beneficiary.updated = 'Beneficiary has been successfully updated.'
        })
        .finally(() => {
          this.beneficiary.canSave = false
          this.beneficiary.editing = null
          this.beneficiary.cached = null
          this.beneficiary.isSaving = false
        })
    },
    cancelEdit () {
      this.beneficiary.canSave = false
      this.beneficiary.editing = null
      this.beneficiary.cached = null
    }
  },
  computed: {
    beneficiaryCategories () {
      return this.$store.getters.categories('beneficiary')
    }
  }
}
</script>
